"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryIcon = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var factory_1 = require("../internal/factory");
var css_types_1 = require("../internal/css-types");
exports.FactoryIcon = factory_1.factory({
    prefix: 'Icon',
    settings: { size: css_types_1.measureUnit },
    component: function (_a) {
        var size = _a.size;
        var Container = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* Set size of icon */\n      height: ", ";\n      width: ", ";\n      font-size: ", ";\n\n      /* Center icon inside */\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    "], ["\n      /* Set size of icon */\n      height: ", ";\n      width: ", ";\n      font-size: ", ";\n\n      /* Center icon inside */\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    "])), size, size, size);
        return function (_a) {
            var icon = _a.icon, restProps = __rest(_a, ["icon"]);
            return (react_1.default.createElement(Container, __assign({}, restProps),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, fixedWidth: true })));
        };
    }
}).FactoryIcon;
var templateObject_1;
